module.exports = __webpack_public_path__ + "img/default_img.53de19f3.png";